import React from 'react';
import { useNavigate } from 'react-router-dom';
import GradientButton from './ui/GradientButton';

/**
 * CandidateList Component
 * 
 * Displays a list of candidates with options to view their profiles.
 */
const CandidateList = ({ candidates = [] }) => {
  const navigate = useNavigate();

  // If no candidates are provided, use mock data
  const displayCandidates = candidates.length > 0 ? candidates : [
    {
      id: 'candidate-1',
      name: 'Alex Johnson',
      title: 'Senior Full Stack Developer',
      experience: 6,
      skills: ['JavaScript', 'React', 'Node.js', 'MongoDB'],
      location: 'San Francisco, CA'
    },
    {
      id: 'candidate-2',
      name: 'Sarah Williams',
      title: 'Frontend Developer',
      experience: 4,
      skills: ['JavaScript', 'React', 'CSS', 'HTML5'],
      location: 'New York, NY'
    },
    {
      id: 'candidate-3',
      name: 'Michael Chen',
      title: 'Backend Developer',
      experience: 5,
      skills: ['Python', 'Django', 'PostgreSQL', 'Docker'],
      location: 'Austin, TX'
    }
  ];

  const handleViewProfile = (candidateId) => {
    navigate(`/candidates/${candidateId}`, { state: { fromAiSearch: false } });
  };

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-md">
      <ul className="divide-y divide-gray-200">
        {displayCandidates.map((candidate) => (
          <li key={candidate.id}>
            <div className="px-4 py-5 sm:px-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">{candidate.name}</h3>
                  <p className="mt-1 max-w-2xl text-sm text-gray-500">{candidate.title}</p>
                </div>
                <div>
                  <GradientButton onClick={() => handleViewProfile(candidate.id)}>
                    View Profile
                  </GradientButton>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <div className="text-sm font-medium text-gray-500">Experience</div>
                  <div className="mt-1 text-sm text-gray-900">{candidate.experience} years</div>
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-500">Location</div>
                  <div className="mt-1 text-sm text-gray-900">{candidate.location}</div>
                </div>
              </div>
              <div className="mt-4">
                <div className="text-sm font-medium text-gray-500">Skills</div>
                <div className="mt-1 flex flex-wrap gap-2">
                  {candidate.skills.map((skill, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CandidateList;
